module.exports = __webpack_public_path__ + "static/img/dominate2.8393d953.png";